<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active">
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          Product Master
        </li>
      </ol>
      <div class="row">
        <div class="col-md-12">
           <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
                          <label>Product Type</label>
                          <selectProductType
                          :selectedOptionArray ="SegmentAlready"
                          :remoteControl="'kspgAPI/ReportAccumulationBySegmentByPart/ProductTypeSearch'"
                           @selectedData="ProductTypeSelect"
                          >
                          </selectProductType>
                        </div>
        </div>
         <div class="col-md-4">
          <div class="form-group">
                          <label>Segment</label>
                          <!-- <v-select
                            v-model="SegmentType"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsSegmentType"
                          ></v-select> -->
                          <selectSegment
                :selectedOptionArray ="SegmentAlready"
                :remoteControl="'kspgAPI/ReportAccumulationBySegmentByPart/PartSegmentSearch'" @selectedData="SegmentSelect"></selectSegment>              
                        </div>
        </div>
        <div class="col-md-3">
          <div class="user-buttonall">
            <ul>
              <li>
                <div class="form-group">
                  <label>Upload Product</label>
                  <input
                    type="file"
                    v-on:change="handleFileUpload()"
                    id="inputFile4"
                    multiple=""
                    ref="file"
                    name="reborer"
                  />
                  <div class="input-group">
                    <input
                      type="text"
                      readonly=""
                      id="addon3"
                      class="form-control"
                      placeholder="CSV File"
                    />
                    <span class="input-group-btn input-group-sm">
                      <button type="button" class="btn btn-fab btn-fab-mini">
                        <i class="material-icons">attach_file</i>
                      </button>
                    </span>
                  </div>
                  <div v-if="message" class="alert-success" role="alert">
                    {{ message }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        
      </div>
      <div class="row">
         
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
              />
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllCoupons(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Search
            </button>
          </div>
        </div>
         <div class="col-md-2" v-if="$can('Create','Loyalty::Product Master') || $can('Delete','Loyalty::Product Master')">
          <div class="form-group">
            <button  class="btn btn-danger submitbtn btn-raised" @click="$router.push('/productMasterDeleted')">Delete List</button>
          </div>
        </div>
        <div class="col-md-2 "  v-if="$can('Create','Loyalty::Product Master')">
          <div class="user-buttonall">
            <br>
            <ul>
              <li>
                <div class="form-group">
                  <router-link to="addProduct">Add Product +</router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-2 "  v-if="$can('Download','Loyalty::Product Master')">
          <div class="form-group">
            <button v-on:click="exportPayment" class="btn btn-outline-primary">Export <i class="material-icons">get_app</i> </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>KS Part Number</th>
                    <th>Descriptions</th>
                    <th>Project</th>
                    <th>Application</th>
                    <th>Point Per Unit</th>
                    <th>Updation Date</th>
                    <th v-if="!$can('Delete','Loyalty::Product Master')">Status</th>
                    <th v-if="$can('Delete','Loyalty::Product Master')">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in product_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td class="left-align">
                      <!-- <router-link
                        :to="{
                          name: 'editReborer',
                          params: { partner_id: item.id },
                        }"
                        ></router-link
                      > -->
                      {{ item.ProductName }}
                    </td>
                    <td>{{ item.Descriptions }}</td>
                    <td>{{ item.Project }}</td>
                    <td>{{item.Application}}</td>
                    <td>{{item.PointPerUnit}}</td>
                    <td>{{ item.modified_date ? item.modified_date : item.created_date | dateFormatReadable }}</td>
                    <td v-if="!$can('Delete','Loyalty::Product Master')">{{item.Active=== "1" ? "Active": "Inactive"}}</td>
                    <td class="statusLIATopan" v-if="$can('Delete','Loyalty::Product Master')">
                    <a href="#" @click="DeactivateProduct(item.id)">{{item.Active=== "1" ? "Active": "InActive"}}</a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="externalScript"></div> -->
  </div>
</template>
<script>


import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import moment from 'moment'
export default {
  name: 'productMaster',
  data() {
    return {
      SuccessMessage:'',
      ErrorMessage:'',
      SegmentAlready:{},
      segmentSelected:'',
      ProductTypeSelected:'',
      product_data: [],
      searchText: '',
      linkExport:'',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      optionsProductType:[
        { value: null, text: 'Please Select Product Type'},
        { value: 'Bearing', text: 'Bearing' },
        { value: 'Bush', text: 'Bush' },
        { value: 'Thrust Washer', text: 'Thrust Washer'},
        { value: 'Engine Valve', text: 'Engine Valve'}
      ],
      optionsSegmentType:[
         { value: null, text: 'Please Select Segment Type'},
          { value: 'Agriculture', text: 'Agriculture'},
           { value: 'Industrial', text: 'Industrial'},
            { value: 'LCV', text: 'LCV'},
            { value: 'M/HCV', text: 'M/HCV'},
            { value: 'Micro-LCV', text: 'Micro-LCV'},
            { value: 'PC Diesel', text: 'PC Diesel'},
            { value: 'PC Gasoline', text: 'PC Gasoline'},
            { value: 'Tractor', text: 'Tractor'}
      ],
      message:''
    };
  },
  components: {
    Paginate,
    
     selectSegment: () => import('../components/Select2SearchWithTokenPrefetch.vue'),
     selectProductType: () => import('../components/Select2SearchWithTokenPrefetch.vue'),
  },
  methods: {
    DeactivateProduct(id){

      let params = {}
      params ="id="+id
       commonServices
        .delete('kspgAPI/Product', params)
        .then((response) => {
            this.SuccessMessage = response.data.message;
            if (response.data.status) {
              this.getAllCoupons(1);
              this.SuccessMessage = response.data.Messaage
            }
          },
          (error) => {
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => (this.SuccessMessage = false), 5000);   
        setTimeout(() => (this.ErrorMessage = false), 5000);
    },
    SegmentSelect(val){
      this.segmentSelected = val;
      this.getAllCoupons(1);
    },
    ProductTypeSelect(val){
      this.ProductTypeSelected = val;
      this.getAllCoupons(1);
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
            
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }
      params['ProductType'] = this.ProductTypeSelected;   
      params['Segment'] = this.segmentSelected;
      params['Active'] = "1";
      return params;
    },
    getAllCoupons(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/Product/list', params)
        .then((response) => {
          const {
            product_data,
            totalItems,
            currentPage,
            TotalPage,
          } = response.data;
          this.product_data = product_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
            loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => {loader.hide()}, 2000)
      this.skyloEnd();
    },
    handleFileUpload() {
      this.uploadFile = this.$refs.file.files[0];
      this.submitFile();
    },
    submitFile() {
      let formData = new FormData();
      formData.append('reborer', this.uploadFile);
      let loader = this.$loading.show();
      commonServices
        .post_upload_file('kspgAPI/Product/upload', formData)
        .then(
          (responce) => {
            this.message = responce.data.message;
            if (responce.data.status) {
              
            }
            loader.hide()
          },
          (error) => {
            //   this.loading = false;
            loader.hide()
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          this.errors.push(e);
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
    },
    exportPayment(){
      alert("Be paitent, We are processing your export Request.");
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        0,
        0
      );
      params['download']=1;
      commonServices
        .get('kspgAPI/Product/list', params)
        .then((response) => {
            if(response.data){
              var dta=response.data.data;
              var csv = '';  
              for(var r of dta){
                csv += '"'+r.join('","').replaceAll("\n",' ')+'"';
                csv += "\n";  
              }  
              var hiddenElement = document.createElement('a');  
              hiddenElement.href  = 'data:text/csv;charset=utf-8,' + encodeURI(csv);  
              hiddenElement.target = '_blank';  
              hiddenElement.download = ' Product_Master_'+new Date().toLocaleString().replaceAll(' ','_')+'.csv';  
              hiddenElement.click();  

            }
            setTimeout(() => {loader.hide()}, 1000)
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
           setTimeout(() => {loader.hide()}, 1000)
            setTimeout(() => (this.ErrorMessage = e.response.data.message), 7000);
        });
       
      setTimeout(() => (this.SuccessMessage = false), 7000);
      setTimeout(() => (this.ErrorMessage = false), 7000);
    },
  },
  mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}
.left-align{
    text-align: left !important;
}
</style>